import script from "./InputAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./InputAttachment.vue?vue&type=style&index=0&id=a834a308&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a834a308"]])

export default __exports__